import { render } from "./StudyLoad.vue?vue&type=template&id=889dee4a"
import script from "./StudyLoad.vue?vue&type=script&lang=js"
export * from "./StudyLoad.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/StudyLoad.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "889dee4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('889dee4a', __exports__)) {
    api.reload('889dee4a', __exports__)
  }
  
  module.hot.accept("./StudyLoad.vue?vue&type=template&id=889dee4a", () => {
    api.rerender('889dee4a', render)
  })

}


export default __exports__